var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTornado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8773_603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8773_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83342 4L2.60009 5.33333H13.4001L14.1668 4C14.4223 3.55556 14.4251 3.11111 14.1751 2.66667C13.9251 2.22222 13.539 2 13.0168 2H2.98342C2.4612 2 2.07509 2.22222 1.82509 2.66667C1.57509 3.11111 1.57787 3.55556 1.83342 4ZM3.36675 6.66667L4.53342 8.66667H11.4668L12.6334 6.66667H3.36675ZM5.30009 10L6.85009 12.6667C7.10564 13.1111 7.48898 13.3333 8.00009 13.3333C8.5112 13.3333 8.89453 13.1111 9.15009 12.6667L10.7001 10H5.30009Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornado);
export default __webpack_public_path__ + "static/media/tornado.97fcee73cfa242b7b6e2cc7029ae535c.svg";
export { ForwardRef as ReactComponent };